import PropTypes from "prop-types";
import TuneIcon from "@mui/icons-material/Tune";
import CloseIcon from "@mui/icons-material/Close";

import { HeaderWrapper, FilterSortTitle, ClearAllLink, CloseButton } from "../../styles";

const Header = ({ handleClearAll, onClose }) => {
  return (
    <HeaderWrapper>
      <FilterSortTitle>
        <TuneIcon sx={{ verticalAlign: "middle" }} /> Filters
      </FilterSortTitle>
      <CloseButton component="button" onClick={onClose}>
        <CloseIcon />
      </CloseButton>
      <ClearAllLink underline="hover" component="button" onClick={handleClearAll}>
        Clear all
      </ClearAllLink>
    </HeaderWrapper>
  );
};

Header.propTypes = {
  handleClearAll: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Header;
